import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'lodash'

import {
  hasAnySim,
  isAllFilled,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroNao,
  isPerguntaOutroSelected,
  isPerguntaOutroSim,
} from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta05ExemplosEnum,
  ConsultaSeguimentoPergunta05Model,
} from './model-consultaSeguimentoPergunta05'

const pergunta05ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta05ExemplosEnum)
const pergunta05ExemplosPassouEnumValues = [
  ConsultaSeguimentoPergunta05ExemplosEnum.OLHA_PARA_AS_MAOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.MOVE_OS_DEDOS_QUANDO_BRINCA_DE_ESCONDER_ROSTO,
]
const pergunta05ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta05ExemplosEnum.MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.AGITA_AS_MAOS_PERTO_DO_ROSTO,
]

export function isPergunta05ExemplosAllNao(value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta05ExemplosEnumValues)
}

export function hasPergunta05ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta05ExemplosFalhouAnySim(value: ConsultaSeguimentoPergunta05Model): boolean {
  const exemplosFalhou = value?.PERGUNTA_05_EXEMPLOS?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && (hasAnySim(exemplosFalhou) || isPerguntaOutroSim(value?.OUTRO))
}

export function isPergunta05ExemplosPassouAllNao(
  value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']
): boolean {
  return isAllNao(value?.PASSOU, pergunta05ExemplosPassouEnumValues)
}

export function isPergunta05ExemplosFalhouAllNao(value: ConsultaSeguimentoPergunta05Model): boolean {
  const isExemplosFalhouAllNao = isAllNao(value?.PERGUNTA_05_EXEMPLOS?.FALHOU, pergunta05ExemplosFalhouEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosFalhouAllNao && isPerguntaOutroNao(value?.OUTRO)
  }

  return isExemplosFalhouAllNao
}

export function isPergunta05ExemplosFalhouAllFilled(value: ConsultaSeguimentoPergunta05Model): boolean {
  const isExemplosFalhouAllFilled = isAllFilled(value?.PERGUNTA_05_EXEMPLOS?.FALHOU, pergunta05ExemplosFalhouEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosFalhouAllFilled && isPerguntaOutroSelected(value?.OUTRO)
  }

  return isExemplosFalhouAllFilled
}

export function prunePergunta05(value: ConsultaSeguimentoPergunta05Model): ConsultaSeguimentoPergunta05Model {
  const pruned: ConsultaSeguimentoPergunta05Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_05_HEADER: value.PERGUNTA_05_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_05_HEADER === SimNaoEnum.SIM
  const hasFalhouSim = hasPergunta05ExemplosFalhouAnySim(value)

  if (isHeaderSim) {
    pruned.PERGUNTA_05_EXEMPLOS = value.PERGUNTA_05_EXEMPLOS
  }

  if (isHeaderSim && hasFalhouSim) {
    pruned.PERGUNTA_05_DUAS_VEZES_POR_SEMANA = value.PERGUNTA_05_DUAS_VEZES_POR_SEMANA
  }

  return pruned
}
